import { DictFilterV2Input, requestsClient } from '@/shared/api';

import { ICountriesV2QueryParams } from '../types';

export const countriesV2Query = async ({
  limit = 10,
  skip = 0,
  search,
}: ICountriesV2QueryParams) => {
  const input: DictFilterV2Input = {
    pagination: { limit, skip },
  };

  if (search?.trim()) input.itemQuery = search;

  const { countriesV2 } = await requestsClient.countriesV2({ input });
  return countriesV2;
};

export const defaultCountryQuery = async (
  defaultCountryCode: string | undefined,
) => {
  const { country } = await requestsClient.defaultCountry({
    input: { code: defaultCountryCode },
  });
  return country ?? null;
};
